import React from 'react'
import KPI from '../../blocks/kpis/KPI'
import PercentageFormatter from '../../formatters/PercentageFormatter'
import Avatar from '../../blocks/users/Avatar'
import CardWide from '../../blocks/cards/CardWide'
import { translateIt } from '../../../data/translations'
import { Route } from '../../../routers/routes'
import Link from 'next/link'
import Styling from '../../styling'

export default function PortfolioListItem(props) {
  const { 
    item, 
    isSideBar=false
  } = props

  const gridClassess = isSideBar ? 'grid-cols-6' : 'grid-cols-6 md:grid-cols-12'

  return (
    <>
      <Link href={Route.portfolioDetail(item)}>
        <CardWide
          className={`${Styling.backgrounds.light}`}
          gridColsClasses={`${gridClassess}  gap-4 p-4`}
          columns={[
            {
              spanClasses: 'col-span-6', 
              content: (
                <>
                  <Avatar
                    isSideBar={isSideBar}
                    imageURL={item.user_avatar_url}
                    imageAlt={`${item.username} profile image`}
                    imageWidth={128}
                    imageHeight={128}
                    username={item.username}
                    description={item.name}
                  />
                </>
              )
            },
            { spanClasses: 'col-span-2', content: <KPI label={`${translateIt(item.country_id, '1week')}`} value={<PercentageFormatter value={item.yield_1w} />} /> },
            { spanClasses: 'col-span-2', content: <KPI label={`${translateIt(item.country_id, '1month')}`} value={<PercentageFormatter value={item.yield_1m} />} /> },
            { spanClasses: 'col-span-2', content: <KPI label={`${translateIt(item.country_id, '3months')}`} value={<PercentageFormatter value={item.yield_3m} />} /> },
          ]}
        />
      </Link>
    </>
  )
}
